import React from 'react';
import Project from '../components/utils/Project';
import styles from './Projects.module.css';
import { projectData } from '../DB/projectsDB';

const Projects = () => {
	return (
		<div className={styles.projectsContainer}>
			<section className={styles.heroSection}>
				<div className={styles.heroContent}>
					<h1 className={styles.heroTitle}>Proiectele Mele</h1>
					<p className={styles.heroSubtitle}>
						Această colecție reunește o selecție a proiectelor mele, ilustrând o evoluție tehnică clară de la aplicații demonstrative la arhitecturi
						software complexe. Portofoliul acoperă o gamă variată de implementări: de la platforme de producție full-stack cu panouri de administrare
						securizate (CMS, RBAC) și soluții e-commerce, până la jocuri RPG browser-based construite pe arhitecturi Client-Server cu motoare logice
						personalizate. Eforturile recente se bazează pe ecosistemul MERN (MongoDB, Express, React/Vite, Node.js), integrând management avansat al
						stării globale, generare procedurală și optimizări asistate de AI. Fiecare proiect confirmă tranziția de la consolidarea conceptelor
						fundamentale (JavaScript, HTML, CSS) către inginerie software aplicată și sisteme scalabile.
					</p>
				</div>
			</section>
			<div className={styles.projectsGrid}>
				{projectData.map((project) => (
					<Project
						key={project.id}
						title={project.title}
						description={project.description}
						imageSrc={project.imageSrc}
						websiteLink={project.websiteLink}
						githubLinkFE={project.githubLinkFE}
						githubLinkBE={project.githubLinkBE}
						tags={project.tags}
					/>
				))}
			</div>
		</div>
	);
};

export default Projects;
